import { Controller } from 'react-hook-form';
import {
  Autocomplete,
  InputSize,
  InputText,
  PermissionEnum,
  Select,
  SelectSize,
  SelectType,
  Textarea,
} from '@ui/src';
import InfoRow from '../../common/info-row';
import StepPartBlock from '../../common/step-part-block';
import { NewApplicationStatus } from '../../../../hoc/common/types';
import { ActivitiesTypes } from './types';

import commonStyles from '../../common/styles.module.css';
import cn from '../styles.module.css';

const Activities = ({
  control,
  sourcesOfFunds,
  activePermissions,
  status,
  clearErrors,
  errors,
  sourceOfFundsIds,
  otherSourceOfFunds,
  clientsActivities,
  employmentActivity,
  clientActivity,
  otherActivity,
  countries,
}: ActivitiesTypes) => (
  <StepPartBlock title="Activities" zIndex={23}>
    <InfoRow
      title="Source of Funds"
      id="sourceOfFundsIds"
      className={cn.sourceOfFundsWrapper}
      lessPadding
    >
      <Controller
        control={control}
        name="sourceOfFundsIds"
        defaultValue={[]}
        render={({ field: { onChange, value } }) => (
          <Select
            name="sourceOfFundsIds"
            placeholder="Select an option"
            list={sourcesOfFunds}
            value={value}
            selectWrapperClassName={
              !activePermissions?.includes(
                PermissionEnum.APPLICATIONS_CUSTOMERS_EDIT_ACTION,
              ) ||
              status === NewApplicationStatus.ACCEPTED ||
              status === NewApplicationStatus.DECLINED
                ? commonStyles.selectDisabled
                : ''
            }
            size={SelectSize.SMALL}
            mode={SelectType.MULTIPLE}
            onChange={(e) => {
              onChange(e);
              clearErrors(['sourceOfFundsIds', 'sourcesOfFunds']);
            }}
            tabIndex={
              !activePermissions?.includes(
                PermissionEnum.APPLICATIONS_CUSTOMERS_EDIT_ACTION,
              ) ||
              Boolean(
                status === NewApplicationStatus.ACCEPTED ||
                status === NewApplicationStatus.DECLINED,
              )
                ? -1
                : 0
            }
            disabled={
              !activePermissions?.includes(
                PermissionEnum.APPLICATIONS_CUSTOMERS_EDIT_ACTION,
              ) ||
              Boolean(
                status === NewApplicationStatus.ACCEPTED ||
                status === NewApplicationStatus.DECLINED,
              )
            }
            error={
              errors?.sourceOfFundsIds?.message ||
              errors?.sourcesOfFunds?.message
            }
            fullWidth
            borderless
          />
        )}
      />
    </InfoRow>
    {sourceOfFundsIds?.includes(otherSourceOfFunds?.value as string) && (
      <InfoRow
        title="Description of source of funds"
        id="sourceOfFundsDescription"
        lessPadding
      >
        <Controller
          control={control}
          name="sourceOfFundsDescription"
          defaultValue=""
          render={({ field: { onChange, value } }) => (
            <Textarea
              name="sourceOfFundsDescription"
              placeholder="Enter description..."
              onChange={(e) => {
                onChange(e);
                clearErrors(['sourceOfFundsDescription']);
              }}
              value={value}
              className={`borderless ${commonStyles.stepOneTextarea} ${commonStyles.pepTextarea}`}
              error={errors?.sourceOfFundsDescription?.message}
              tabIndex={
                !activePermissions?.includes(
                  PermissionEnum.APPLICATIONS_CUSTOMERS_EDIT_ACTION,
                ) ||
                Boolean(
                  status === NewApplicationStatus.ACCEPTED ||
                  status === NewApplicationStatus.DECLINED,
                )
                  ? -1
                  : 0
              }
              disabled={
                !activePermissions?.includes(
                  PermissionEnum.APPLICATIONS_CUSTOMERS_EDIT_ACTION,
                ) ||
                Boolean(
                  status === NewApplicationStatus.ACCEPTED ||
                  status === NewApplicationStatus.DECLINED,
                )
              }
            />
          )}
        />
      </InfoRow>
    )}
    <InfoRow title="Activity of the client" id="clientActivityId" lessPadding>
      <Controller
        control={control}
        name="clientActivityId"
        defaultValue=""
        render={({ field: { onChange, value } }) => (
          <Select
            name="clientActivityId"
            placeholder="Select an option"
            list={clientsActivities?.filter(
              (item) => item.name !== 'Business Owner',
            )}
            value={value}
            selectWrapperClassName={
              status === NewApplicationStatus.ACCEPTED ||
              status === NewApplicationStatus.DECLINED
                ? commonStyles.selectDisabled
                : ''
            }
            size={SelectSize.SMALL}
            onChange={(e) => {
              onChange(e);
              clearErrors(['clientActivityId']);
            }}
            error={errors?.clientActivityId?.message}
            tabIndex={
              !activePermissions?.includes(
                PermissionEnum.APPLICATIONS_CUSTOMERS_EDIT_ACTION,
              ) ||
              Boolean(
                status === NewApplicationStatus.ACCEPTED ||
                status === NewApplicationStatus.DECLINED,
              )
                ? -1
                : 0
            }
            disabled={
              !activePermissions?.includes(
                PermissionEnum.APPLICATIONS_CUSTOMERS_EDIT_ACTION,
              ) ||
              Boolean(
                status === NewApplicationStatus.ACCEPTED ||
                status === NewApplicationStatus.DECLINED,
              )
            }
            fullWidth
            borderless
          />
        )}
      />
    </InfoRow>
    {employmentActivity?.value === clientActivity && (
      <>
        <InfoRow title="Name of employer" id="nameOfEmployer" lessPadding>
          <Controller
            control={control}
            name="nameOfEmployer"
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <InputText
                name="nameOfEmployer"
                placeholder="Enter name of employer"
                value={value}
                onChange={(e) => {
                  onChange(e);
                  clearErrors(['nameOfEmployer']);
                }}
                error={errors?.nameOfEmployer?.message}
                size={InputSize.SMALL}
                className="borderless"
                tabIndex={
                  !activePermissions?.includes(
                    PermissionEnum.APPLICATIONS_CUSTOMERS_EDIT_ACTION,
                  ) ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                disabled={
                  !activePermissions?.includes(
                    PermissionEnum.APPLICATIONS_CUSTOMERS_EDIT_ACTION,
                  ) ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
              />
            )}
          />
        </InfoRow>
        <InfoRow title="Position" id="employeePosition" lessPadding>
          <Controller
            control={control}
            name="employeePosition"
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <InputText
                name="employeePosition"
                placeholder="Enter position"
                value={value}
                onChange={(e) => {
                  onChange(e);
                  clearErrors(['employeePosition']);
                }}
                size={InputSize.SMALL}
                error={errors?.employeePosition?.message}
                className="borderless"
                tabIndex={
                  !activePermissions?.includes(
                    PermissionEnum.APPLICATIONS_CUSTOMERS_EDIT_ACTION,
                  ) ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                disabled={
                  !activePermissions?.includes(
                    PermissionEnum.APPLICATIONS_CUSTOMERS_EDIT_ACTION,
                  ) ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
              />
            )}
          />
        </InfoRow>
        <InfoRow
          title="Country of Employment"
          id="countryOfEmployerId"
          lessPadding
        >
          <Controller
            control={control}
            name="countryOfEmployerId"
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <Autocomplete
                name="countryOfEmployerId"
                placeholder="Select country..."
                list={countries || []}
                value={value}
                className={`${commonStyles.newApplicationAutocomplete} ${
                  status === NewApplicationStatus.ACCEPTED ||
                  status === NewApplicationStatus.DECLINED
                    ? commonStyles.newApplicationAutocompleteDisabled
                    : ''
                }`}
                error={errors?.countryOfEmployerId?.message}
                size={SelectSize.SMALL}
                onChange={(e) => {
                  onChange(e);
                  clearErrors(['countryOfEmployerId']);
                }}
                borderless
                tabIndex={
                  !activePermissions?.includes(
                    PermissionEnum.APPLICATIONS_CUSTOMERS_EDIT_ACTION,
                  ) ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                disabled={
                  !activePermissions?.includes(
                    PermissionEnum.APPLICATIONS_CUSTOMERS_EDIT_ACTION,
                  ) ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
                fullWidth
              />
            )}
          />
        </InfoRow>
      </>
    )}
    {otherActivity?.value === clientActivity && (
      <InfoRow
        title="Description of activity"
        id="typeOfActivityDescription"
        lessPadding
      >
        <Controller
          control={control}
          name="typeOfActivityDescription"
          defaultValue=""
          render={({ field: { onChange, value } }) => (
            <Textarea
              name="typeOfActivityDescription"
              placeholder="Enter description..."
              onChange={(e) => {
                onChange(e);
                clearErrors(['typeOfActivityDescription']);
              }}
              value={value}
              className={`borderless ${commonStyles.stepOneTextarea} ${commonStyles.pepTextarea}`}
              error={errors?.typeOfActivityDescription?.message}
              tabIndex={
                !activePermissions?.includes(
                  PermissionEnum.APPLICATIONS_CUSTOMERS_EDIT_ACTION,
                ) ||
                Boolean(
                  status === NewApplicationStatus.ACCEPTED ||
                  status === NewApplicationStatus.DECLINED,
                )
                  ? -1
                  : 0
              }
              disabled={
                !activePermissions?.includes(
                  PermissionEnum.APPLICATIONS_CUSTOMERS_EDIT_ACTION,
                ) ||
                Boolean(
                  status === NewApplicationStatus.ACCEPTED ||
                  status === NewApplicationStatus.DECLINED,
                )
              }
            />
          )}
        />
      </InfoRow>
    )}
  </StepPartBlock>
);

export default Activities;
